import React from "react";
import { CheckCircleGreen } from "../../assets/images";
import "./style.scss";

type AppProps = {
  handleReset: () => void;
  onClose?: () => void;
  history: any;
  clientCode: string | null;
};

const VerificationSuccess = ({
  handleReset,
  onClose,
  history,
  clientCode,
}: AppProps) => {
  return (
    <div className="flex-center" style={{ flexDirection: "column" }}>
      <div>
        <img
          width={"120vw"}
          height={"120vh"}
          src={CheckCircleGreen}
          alt="check"
        />
      </div>

      <div
        className="mt-2 mb-1 bold header"
        style={{ textAlign: "center", width: "70%" }}
      >
        Asset scanned successfully!
      </div>

      <div
        className="mt-2 mb-2 text"
        style={{ textAlign: "center", width: "80%" }}
      >
        Your asset has been scanned and it's condition updated successfully.
        Click below to scan new asset.
      </div>
      {/* 
      <button
        className="btn btn-primary mt-2 mb-1"
        onClick={() => handleReset()}
      >
        Scan New Asset
      </button> */}

      <div
        className="mt-2"
        style={{ color: "#dd4433", cursor: "pointer" }}
        onClick={() => {
          handleReset();
          onClose && onClose();
          history.push({
            pathname: `/fixed-asset-register/physical-verification/${clientCode}`,
            state: { client_code: clientCode },
          });
        }}
      >
        Back to listing
      </div>
    </div>
  );
};

export default VerificationSuccess;
